<template>

    <div v-if="global.candidate!=null">

        <div v-if="global.candidate.Donors.length>0">


            <q-bar class="bg-black text-white text-caption">
                <div class="text-h6">
                    Approximately {{currency(global.candidate.DonorTotal)}} from {{global.candidate.uniqueDonors}}
                    donors.
                </div>
            </q-bar>


            <q-scroll-area class="fill-tab">

                <q-list class="q-pa-md">
                    <q-item v-for="(donor,i) in global.candidate.Donors">
                        <q-item-section style="margin-bottom:15px;">

                            <div style="color:grey;">{{i+1}}</div>

                            <q-item-label class="text-h6" :class="{'donor-match':donor.searchMatch}">
                                {{donor.Name}}
                                <!-- <q-icon v-if="donor.searchMatch" name="search" color="orange" class="float-right" /> -->
                                <div v-if="donor.searchMatch" color="orange" class="float-right text-subtitle1">
                                    donor
                                    search</div>

                            </q-item-label>
                            <q-item-label class="text-subtitle1 text-grey">{{donor.Date}}</q-item-label>
                            <q-item-label class="text-h6 text-green">{{currency(donor.Amount)}}</q-item-label>

                        </q-item-section>




                    </q-item>

                </q-list>

            </q-scroll-area>

        </div>
        <div v-else class="fill-tab">No Information.</div>
    </div>





</template>


<script>
    const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })

    import { global } from './Global.js';


    export default {
        name: 'Funding',
        data() {
            return {
                candidate: global.candidate,

                global
            }

        },
        methods: {
            currency(value) {
                return formatter.format(value);
            }
        }

    }
</script>

<style scoped>
    .donor-match {
        color: orange;
    }

    .my-card {
        width: 100%;
        max-width: 250px;

        background-color: black;
    }

    .fill-tab {
        height: calc(100vh - 375px);
    }
</style>